import React from "react";

import Heading from "components/heading";
import { sendAnalyticEvent } from "components/layout/page/use-page";
import Image from "next/image";
import BackgroundImage from "public/images/enerflo-background-solarfarm-birdseye.png";

import HeroSection from "../../hero-section";

const title = "Careers";

const Careers = () => (
  <div className="relative overflow-hidden">
    <Image
      src={BackgroundImage}
      alt="Enerflo Solarfarm Birdseye Background"
      layout="fill"
      className="object-center object-cover"
      lazyBoundary="400px"
    />
    <div className="absolute inset-0 h-[150%] bg-gradient-to-b md:bg-gradient-to-br from-white to-transparent" />
    <div className="absolute inset-0 h-[150%] bg-gradient-to-b md:bg-gradient-to-r from-white to-transparent" />

    <HeroSection title={title} className="relative h-full">
      <div className="mb-44 md:my-20 md:w-2/3 lg:w-1/2">
        <div className="flex-grow px-6 text-center w-full z-[1] overflow-hidden shadow-md py-6 backdrop-filter backdrop-blur firefox:bg-white firefox:bg-opacity-50 sm:px-10 sm:text-left md:text-left md:backdrop-blur-3xl md:rounded-2xl lg:px-14">
          <HeroSection.Header className="md:items-start">
            <Heading tag="h2">{title}</Heading>
          </HeroSection.Header>

          <div className="space-y-6">
            <p>
              As we grow, we’re always looking for the rare elite to join our team, help make Enerflo the best it can be
              and join our mission to make solar affordable for, and available to, every human on the planet!
            </p>
            <p>
              Enerflo employees can work from virtually anywhere in the world, creating the flexibility and autonomy
              needed to continue to move the needle.
            </p>
            <a
              href="https://enerflo.workable.com"
              target="_blank"
              rel="noreferrer"
              className="btn btn-navy"
              onClick={() => sendAnalyticEvent("Utility Button", "Buttons", "See Current Jobs")}
            >
              See Current Jobs
            </a>
          </div>
        </div>
      </div>
    </HeroSection>
  </div>
);

export default Careers;
